import React, {useContext} from "react";
import {Context} from "context";
import PropTypes from "prop-types";

import ReactDropdown from "react-dropdown";

import styles from "./Filters.module.scss";

export default function Filters(props) {
    const context = useContext(Context);

    const changeMapPack = (event) => {
        window.location.href = `/${context.id}?mapPack=${event.value}`;
    };
    
    return (
        <div className={`bgTertiary ${styles.filters}`}>
            <div data-hint={context.text.hints.mapPackSelector} className={styles.mapPackSelector}>
                <ReactDropdown
                    options={context.mapPacks.map((mapPack) => {
                        return {value: mapPack.name, label: `${mapPack.name} Map Pack (${mapPack.mapCount} Maps)`}
                    })}
                    value={context.mapPack}
                    onChange={changeMapPack}
                    className="highlightSecondary"
                    menuClassName="bgSecondary highlightSecondary"
                />
            </div>

            <div className={styles.search}>
                <input
                    type="text"
                    placeholder="Search maps..."
                    name="search"
                    value={props.search}
                    onChange={(e) => { props.setSearch(e.target.value) }}
                    id="search"
                    data-hint={context.text.hints.search}
                    className="highlightSecondary bgSecondary"
                />
                {props.search.length > 0 &&
                    <img className={styles.resetSearch} src={require(`images/icons/resetSearch-dark.svg`)} alt="X" onClick={() => { props.setSearch("") }} />
                }
            </div>
        </div>
    )
}

Filters.propTypes = {
    search: PropTypes.string.isRequired,
    setSearch: PropTypes.func.isRequired
}